module.exports = __webpack_public_path__ + "img/exception_locals.7e3f54ad.png";